import { useTheme } from 'styled-components'

import { Tag, Text } from '@reveni-io/reveni-ui'

import { getSentimentTypes } from '../helpers'

const SentimentTag = ({ type, label }) => {
  const theme = useTheme()
  const sentiment = getSentimentTypes(theme)[type]

  const { Icon, iconColor, backgroundColor, borderColor } = sentiment

  if (!sentiment) return null

  return (
    <Tag backgroundColor={backgroundColor} borderColor={borderColor}>
      <Icon size={16} weight="regular" color={iconColor} />
      <Text type="bodyMMedium">{label}</Text>
    </Tag>
  )
}

export default SentimentTag
